/**
 * Replaces the label text with the replacement value.
 *
 * @param {Element} label - The label to change
 * @param {string} text - The new text for the label
 */
export default function replaceLabelText(label, text) {
  label.innerHTML = label.innerHTML.replace(/^.*?( \*)?$/, `${text}$1`);
}
